import React from "react";
import Navigator from "../../../components/navigator/Navigator";

export const ConnectToWhatsappTroubleshooting = ({ id, scrollTo }: { id: string, scrollTo: (sectionId: string) => (event: any) => void }) => {
    return (
        <>
            <div className="description">
                Troubleshooting: Why Your WhatsApp Account Is Not Connected
            </div>

            <div className="sub-section">
                If your WhatsApp Business account is not connecting or showing errors, here are the most common reasons and how to resolve them:
            </div>

            <div className="sub-section">
                <ol>
                    <li><div>
                        <div>Phone Number Already in Use</div>
                        The phone number is linked to a private (personal) WhatsApp account.
                        The number is already connected to a different WhatsApp Business account.
                        <div>To fix this, you’ll need to <span className="link" onClick={scrollTo('remove-phone-number-from-meta-business-suite')}>remove the number</span> from the other account before reconnecting.</div>
                    </div></li>
                    <li><div>
                        <div>Missing Business Requirements</div>
                        Your shop does not have a published Privacy Policy.
                        There is no Contact Form or visible customer support info on your website.
                        <div>Meta requires these to verify and approve your business.</div>
                    </div></li>
                    <li><div>
                        <div>Meta Business Verification Issues</div>
                        Your business verification in Meta Business Manager is incomplete or pending.
                        The documents you submitted (e.g., business registration, tax info) were rejected.
                        <div>Check your Business Settings → Business Info to confirm verification status.</div>
                    </div></li>
                    <li><div>
                        <div>Policy Violations</div>
                        Your business category, products, or services may violate WhatsApp Commerce Policy (e.g., restricted products like alcohol, tobacco, or financial services without licenses).
                        Content on your website or shop doesn’t align with Meta’s advertising and commerce rules.
                    </div></li>
                    <li><div>
                        <div>Pending Admin Approval</div>
                        The person trying to connect the account does not have the right admin role in Meta Business Manager.
                        <div>Ensure you’re logged in with an account that has Admin access.</div>
                    </div></li>
                    <li><div>
                        <div>Delays in Meta Systems</div>
                        Even after removing or updating the number, Meta may take 5–10 minutes (sometimes longer) to fully release it.
                        <div>If you just made changes, wait a bit and try again.</div>
                    </div></li>
                </ol>
            </div>

            <div className="sub-section">Still can’t connect to WhatsApp? Reach out at <a href="mailto:support@vuelve.co">support@vuelve.co</a></div>
        </>
    );
}